import { FC, useEffect } from "react";
import { useSelector } from "react-redux";
import { Redirect, Route, Switch } from "react-router";

import { newFeaturesCampaigns } from "constants/campaigns";
import { TicketsRoutes, getPathForRoute } from "constants/tickets/TicketsRoutes";
import { isInIframe } from "helpers/app";
import { IWithBreakpointsProps, withBreakpoints } from "helpers/withBreakpoints";
import { useNewFeatureForAgents } from "hooks/use-new-feature-for-agents";
import { selectFeatureToggleMacros } from "store/entities/license";

import { AutomationsRoutes } from "./constants";
import Macros from "./macros/Macros";
import { AutomationsWorkflowsRouter } from "./workflows/AutomationsWorkflowsRouter";

const Router: FC<IWithBreakpointsProps> = ({ isMobile }) => {
  const { isNewForAgent, featureFlagValue, setAgentFlagCallback } = useNewFeatureForAgents(
    newFeaturesCampaigns.hasSeenAutomationsSection.flag,
    newFeaturesCampaigns.hasSeenAutomationsSection.campaignStartDate
  );
  const featureToggleMacros = useSelector(selectFeatureToggleMacros);

  const isEmbeddedInIframe = isInIframe();

  useEffect(() => {
    if (!featureFlagValue && isNewForAgent) {
      setAgentFlagCallback();
    }
  }, [featureFlagValue, isNewForAgent, setAgentFlagCallback]);

  if (isMobile && !isEmbeddedInIframe) {
    return <Redirect to={getPathForRoute(TicketsRoutes.All)} />;
  }

  return (
    <Switch>
      <Route path={AutomationsRoutes.Rules} component={AutomationsWorkflowsRouter} />
      {featureToggleMacros && <Route path={AutomationsRoutes.Macros} component={Macros} />}
      <Redirect from={`${AutomationsRoutes.Workflows}/add`} to={AutomationsRoutes.AddRule} />
      <Redirect from={`${AutomationsRoutes.Workflows}/edit/:id`} to={`${AutomationsRoutes.EditRule}/:id`} />
      <Redirect to={AutomationsRoutes.Rules} />
    </Switch>
  );
};

export const AutomationsRouter = withBreakpoints(Router);
